import { DRAW_RESULT_TN } from "./types";

const init = {
    data: {}
};
const draw = (state = init, { type, payload }) => {
    switch (type) {
        case DRAW_RESULT_TN:
            return {
                ...state,
                isLoading: false,
                data: payload
            };
        default:
            return state;
    }
}
export default draw;
